import resultFactory from '~/utils/resultFactory'

/**
 @since 2021-12-03
 @author Jaeuk Ryu <wj_tams_dev02>
 */

export const state = () => ({
  AdSettingUrl: '/api/sm/auth/ad-cm', // AD 설정 URL
  AdSyncUrl: '/api/sm/auth/ad-cm/sync', // AD 사용여부 설정 URL
  AdUrl: '/api/sm/auth', // AD URL
  defaultId: -1, // 설정 추가용 ID
  settingDataList: [], // 설정 데이터 리스트
  authServerDataList: [], // AD 조회 리스트

  // addServerResult: 'OK', // 서버 추가시 중복 테스트 용도
  selectedStoreItem: {} // 수정중인 항목 모든탭 동일
})

export const mutations = {
  clearStore: (state) => {
    state.defaultId = -1
    state.settingDataList = [] // 설정 데이터 리스트
    state.authServerDataList = [] // AD 조회 리스트
    state.selectedStoreItem = []
  },
  clearServerDataList: (state) => {
    state.authServerDataList = [] // AD 조회 리스트
  },
  getDefaultId: (state, data) => {
    state.defaultId = data.authsvr_ad_cm_id
  },

  // 서버 Reference 조회
  // getServerReference: (state, item) => { // need to check
  //   // state.serverReference = item
  //   let serverRef = _.clone(state.serverReference)
  //   const keys = Object.keys(state.serverReference)
  //   _.forEach(keys, key => {
  //     if (item[key]) {
  //       serverRef[key] = item[key]
  //     } else {
  //       serverRef[key] = []
  //     }
  //   })
  //   state.serverReference = serverRef
  // },

  setSelectedStoreItem: (state, item) => {
    state.selectedStoreItem = item
  },
  getSettingDataList: (state, item) => {
    state.settingDataList = _.cloneDeep(item)
  },

  editAuthServerListDataAction: (state, data) => {
    state.settingDataList = _.map(state.settingDataList, (item) => {
      if (item.authsvr_ad_cm_id === data.authsvr_ad_cm_id) {
        item = _.cloneDeep(data)
        // item.protocolName = getProtocolName(item)
      }
      return item
    })
  },

  authServerHeaderMutation: (state, data) => {
    state.settingDataList = _.map(state.settingDataList, (item) => {
      item.authsvr_ad_cm_sync_yn = data
      return item
    })
  },

  delSettingDataList: (state, item) => {
    _.forEach(item, (p) => {
      const idx = _.findIndex(state.settingDataList, {authsvr_ad_cm_id: p.authsvr_ad_cm_id})
      if (idx >= 0) {
        state.settingDataList.splice(idx, 1)
      }
    })
  },

  getAdDataList: (state, item) => {
    state.authServerDataList = _.cloneDeep(item)
  },
  addAdData: (state, item) => {
    state.authServerDataList.push(_.cloneDeep(item))
  },
  editAdData: (state, item) => {
    const idx = _.findIndex(state.authServerDataList, {authsvr_ad_id: item.authsvr_ad_id})
    state.authServerDataList.splice(idx, 1, item)
  },
  delAdDataList: (state, item) => {
    _.forEach(item, (p) => {
      const idx = _.findIndex(state.authServerDataList, {authsvr_ad_id: p.authsvr_ad_id})
      if (idx >= 0) {
        state.authServerDataList.splice(idx, 1)
      }
    })
  }
}

export const actions = {
  async getSettingDataList ({commit, state}) { // 인증 서버 설정 조회
    try {
      const data = await this.$axios.$get(state.AdSettingUrl)
      return resultFactory(commit, {length: null, data: data, action: 'getSettingDataList', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  async addSettingData ({commit, state}, payload) { // 인증 서버 설정 추가/ 편집
    try {
      const data = await this.$axios.$put(state.AdSettingUrl, payload, {successAlert: false})
      return resultFactory(commit, {length: null, data: data, action: null, param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  async editSettingData ({commit, state}, payload) { // 인증 서버 통합 편집
    try {
      const data = await this.$axios.$put(state.AdSettingUrl, payload, {successAlert: false})
      return resultFactory(commit, {length: null, data: data, action: null, param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  async delSettingDataList ({commit, state}, payload) {
    let isMulty = false
    const idList = []
    const delList = []
    if (payload.length > 1) {
      isMulty = true
    }
    payload.forEach((item) => {
      idList.push({'authsvr_ad_cm_id': item.authsvr_ad_cm_id})
      delList.push(item.authsvr_ad_cm_id)
    })
    try {
      const data = isMulty ? await this.$axios.$delete(state.AdSettingUrl, {data: {items: delList}}, {failAlert: false})
        : await this.$axios.$delete(`${state.AdSettingUrl}/${payload[0].authsvr_ad_cm_id}`)

      return resultFactory(commit, {length: idList.length, data: data, action: null, param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },

  async editAuthServerDataAction ({commit, state, dispatch}, payload) {
    try {
      const data = await this.$axios.$put(state.AdSyncUrl, payload, {failAlert: false})
      return resultFactory(commit, {length: payload.length, data: data, action: null, param: 'edit'})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  async editAuthServerListDataAction ({commit, state, dispatch}, payload) {
    try {
      const data = await this.$axios.$put(`${state.AdSyncUrl}/${payload[0].authsvr_ad_cm_id}`, _.pick(payload[0], ['authsvr_ad_cm_sync_yn']), {failAlert: false})
      return resultFactory(commit, {length: payload.length, data: data, action: null, param: 'edit'})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },

  async getDefaultId ({commit, state}) { // 설정 추가용 ID 조회
    try {
      const data = await this.$axios.$post(state.AdSettingUrl, null, {successAlert: false})
      return resultFactory(commit, {length: null, data: data, action: 'getDefaultId', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // AD //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  async getAdDataList ({commit, state}) {
    try {
      const data = await this.$axios.$get(`${state.AdUrl}/${state.defaultId}/ad`)
      return resultFactory(commit, {length: null, data: data, action: 'getAdDataList', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  async addAdData ({commit, state, dispatch}, payload) { // 인증 서버 추가.
    const param = makePayload(_.cloneDeep(payload), 'add')
    try {
      const data = await this.$axios.$post(`${state.AdUrl}/${state.defaultId}/ad`, param)
      return resultFactory(commit, {length: null, data: data, action: 'addAdData', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  async editAdData ({commit, state, dispatch}, payload) {
    const param = makePayload(_.cloneDeep(payload), 'edit')
    try {
      const data = await this.$axios.$put(`${state.AdUrl}/${state.defaultId}/ad/${payload.authsvr_ad_id}`, param)
      return resultFactory(commit, {length: null, data: data, action: 'editAdData', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  async delAdDataList ({commit, state}, payload) {
    let isMulty = false
    const idList = []
    const delList = []
    if (payload.length > 1) {
      isMulty = true
    }
    payload.forEach((item) => {
      idList.push({'authsvr_ad_id': item.authsvr_ad_id})
      delList.push(item.authsvr_ad_id)
    })
    try {
      const data = isMulty ? await this.$axios.$delete(`${state.AdUrl}/${state.defaultId}/ad`, {data: {items: delList}}, {failAlert: false})
        : await this.$axios.$delete(`${state.AdUrl}/${state.defaultId}/ad/${payload[0].authsvr_ad_id}`)
      return resultFactory(commit, {length: idList.length, data: data, action: 'delAdDataList', param: idList})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  }
  // AD //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
}

function makePayload (param, type) {
  const serverKeyMap = {
    name: 'ad_svr_name',
    ip: 'ad_svr_ip',
    port: 'ad_svr_port',
    ad_svr_id: 'ad_svr_id'
  }
  const server = []
  _.forEach(param.servers, (item) => {
    server.push(_.omit(_.mapKeys(item, (value, key) => {
      return serverKeyMap[key]
    }), ['undefined', 'itemIndex']))
  })
  param.servers = server

  if (type === 'add') {
    param.authsvr_ad_passwd = btoa(param.passwd)
  } else {
    if (param.passwd.length > 0) {
      param.authsvr_ad_passwd = btoa(param.passwd)
    }
  }

  const payloadKeyMap = {
    authsvr_ad_id: 'authsvr_ad_id',
    name: 'authsvr_ad_name',
    base_dn: 'authsvr_ad_base_dn',
    bind_dn: 'authsvr_ad_bind_dn',
    conn_type: 'authsvr_ad_conn_type',
    account_type: 'authsvr_ad_account_type',
    tm_limit: 'authsvr_ad_tm_limit',
    bind_tm_limit: 'authsvr_ad_bind_tm_limit',
    retry_intval: 'authsvr_ad_retry_intval',
    auth_only: 'authsvr_ad_auth_only',
    is_sec_group_use: 'authsvr_ad_is_sec_group_use',
    sec_group: 'authsvr_ad_sec_group',
    use_admin_level_check: 'authsvr_ad_use_admin_level_check',
    use_admin_ip_check: 'authsvr_ad_use_admin_ip_check',
    desc: 'authsvr_ad_desc',
    servers: 'servers',
    authsvr_ad_passwd: 'authsvr_ad_passwd'
  }
  return _.omit(_.mapKeys(param, (value, key) => {
    return payloadKeyMap[key]
  }), ['undefined'])
}
